import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-slider-operario',
  templateUrl: './slider-operario.component.html',
  styleUrls: ['./slider-operario.component.css']
})
export class SliderOperarioComponent implements OnInit {

  public mr: NgbModalRef;
  public vecActividades = []; public vecOpciones = [];

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService, private ruta: Router) { }

  ngOnInit() {
    this.verActividadesRol();
  }
  //FUNCION QUE PERMITE VER LAS ACTIVIDADES QUE TIENE ASIGNADO EL ROL ACTUAL
  async verActividadesRol() {
    this.vecActividades = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPermisos(8, localStorage.getItem('ciUsuario'), localStorage.getItem("idUser"), 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objAct of res.permiso) {
        this.vecActividades.push({
          idUsuario: objAct.intIdPersona, cedula: objAct.strCedula, idRol: objAct.intIdRol, nombRol: objAct.strNombre, idActividad: objAct.intPadreOpcion,
          nombActividad: objAct.nombActividad
        });
      }
      this.verOpcionesRol();
    }
    //this.cargando.cerrar();
  }
  //FUNCION PARA VER LAS OPCIONES QUE TIENE EL ROL DENTRO DE CADA ACTIVIDAD
  async verOpcionesRol() {
    this.vecOpciones = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPermisos(9, localStorage.getItem('ciUsuario'), localStorage.getItem("idUser"), 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objOpc of res.permiso) {
        this.vecOpciones.push({
          cedula: objOpc.strCedula, idRol: objOpc.intIdRol, idActividad: objOpc.intPadreOpcion, nombActividad: objOpc.nombActividad, idOpcion: objOpc.intIdOpcion,
          nombOpcion: objOpc.nombOpcion, urlOpcion: objOpc.strUrl, tipo: objOpc.tipo
        });
      }
    }
  }
  async verAcciones(ruta, opcion, actividad, modulo, nombModulo, idBeca) {
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPermisos(10, localStorage.getItem("idUser"), opcion, actividad).subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      localStorage.setItem('insUser', res.permiso[0]['bitInsertar']);
      localStorage.setItem('modUser', res.permiso[0]['bitMmodificar']);
      localStorage.setItem('delUser', res.permiso[0]['bitEliminar']);
      localStorage.setItem('cualOpc', modulo);
      localStorage.setItem('modNom', nombModulo);
      localStorage.setItem('modBeca', idBeca);
      this.ruta.navigate(['/gestion/' + ruta]);
    }
  }
  irPagina(ruta) {
    this.ruta.navigate(['/gestion']);
    this.verAcciones(ruta['urlOpcion'], ruta['idOpcion'], ruta['idActividad'], ruta['tipo'], ruta['nombActividad'], ruta['tipo']);
  }
}
